// extracted by mini-css-extract-plugin
export default {"Container":"TQnyLlXyRUlQWR6oD0_h","Providers":"m2HngS0y16A_HPIa2wU8"};